import React from "react";
import { Spinner, Flex } from "@chakra-ui/react";
import { Wrapper } from "components";
import { useAuth } from "duck";
import { useOrganizationQuery } from "requests";
import { Edit, View } from "./components";
import { utils } from "./duck";

const General: React.FC = () => {
  const [{ user }] = useAuth();
  const [mode, setMode] = React.useState<"edit" | "view">("view");

  const { data, loading } = useOrganizationQuery({
    variables: {
      _id: user.organization?._id || 0
    }
  });

  const initialValues = utils.getInitialValues(data?.organization);

  if (loading) {
    return (
      <Wrapper>
        <Flex justifyContent="center">
          <Spinner />
        </Flex>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      {mode === "edit" ? (
        <Edit initialValues={initialValues} onCancel={() => setMode("view")} />
      ) : (
        <View initialValues={initialValues} onEdit={() => setMode("edit")} />
      )}
    </Wrapper>
  );
};

export default General;
